import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import QRScanner from '../../../features/qr-scanner/QRScanner';
import './BottomNav.css';

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showScanner, setShowScanner] = useState(false);
  
  // Get the current active item based on the route
  const getActiveItem = () => {
    if (location.pathname === '/') return 'home';
    if (location.pathname === '/search') return 'search';
    if (location.pathname === '/scan') return 'scan';
    if (location.pathname === '/alerts') return 'alerts';
    if (location.pathname === '/history') return 'history';
    return 'home';
  };

  const [activeItem, setActiveItem] = useState(getActiveItem());

  const handleItemClick = (item) => {
    // Special handling for scan button
    if (item === 'scan') {
      setShowScanner(true);
      return;
    }
    
    setActiveItem(item);
    
    // Navigate to the appropriate route
    switch(item) {
      case 'home':
        navigate('/');
        break;
      case 'search':
        navigate('/search');
        break;
      case 'alerts':
        navigate('/alerts');
        break;
      case 'history':
        navigate('/history');
        break;
      default:
        navigate('/');
    }
  };

  const closeScanner = () => {
    setShowScanner(false);
  };

  return (
    <>
      <nav className="bottom-nav">
        <div 
          className={`nav-item ${activeItem === 'home' ? 'active' : ''}`}
          onClick={() => handleItemClick('home')}
        >
          <i className="fas fa-home"></i>
          <span>Home</span>
        </div>
        <div 
          className={`nav-item ${activeItem === 'search' ? 'active' : ''}`}
          onClick={() => handleItemClick('search')}
        >
          <i className="fas fa-search"></i>
          <span>Search</span>
        </div>
        <div 
          className="nav-item scan-item"
          onClick={() => handleItemClick('scan')}
        >
          <i className="fas fa-qrcode"></i>
          <span>Scan</span>
        </div>
        <div 
          className={`nav-item ${activeItem === 'alerts' ? 'active' : ''}`}
          onClick={() => handleItemClick('alerts')}
        >
          <i className="fas fa-bell"></i>
          <span>Alerts</span>
        </div>
        <div 
          className={`nav-item ${activeItem === 'history' ? 'active' : ''}`}
          onClick={() => handleItemClick('history')}
        >
          <i className="fas fa-history"></i>
          <span>History</span>
        </div>
      </nav>
      
      {showScanner && <QRScanner onClose={closeScanner} />}
    </>
  );
};

export default BottomNav;